import { combineReducers } from 'redux';
import globalSearch from './globalSearch';
import permissions from './permissions';
import acceleratedPayout from './acceleratedPayout';
import abandonedUsers from './abandonedUsers';
import adjustments from './adjustments';
import adjustmentGroups from './adjustmentGroups';
import anomalies from './anomalies';
import auth from './auth';
import cohorts from './cohorts';
import collections from './collections';
import vendorTransfers from './vendorTransfers';
import eligibleInvoices from './eligibleInvoices';
import enablementV2 from './enablementV2';
import vendorEmailSequences from './vendorEmailSequences';
import actionItems from './actionItems';
import invoices from './invoices';
import invoiceQuarantines from './invoiceQuarantines';
import invoiceLineItems from './invoiceLineItems';
import onboardings from './onboardings';
import reconciliation from './reconciliation';
import partnerIntegrations from './partnerIntegrations';
import programs from './programs';
import vendors from './vendors';
import clients from './clients';
import facilitators from './facilitators';
import externalClients from './externalClients';
import externalClientVendors from './externalClientVendors';
import externalVendors from './externalVendors';
import kpis from './kpis';
import invoiceApprovals from './invoiceApprovals';
import invoiceAdjustmentApprovals from './invoiceAdjustmentApprovals';
import revenue from './revenue';
import batchSweeps from './batchSweeps';
import repaymentItems from './repaymentItems';
import tasks from './tasks';
import vendorDocuments from './vendorDocuments';
import vendorSurveys from './vendorSurveys';
import { aprPortfolioApi } from '../api/aprPortfolio';
import { paymentsApi } from '../api/payments';
import { invoicesApi } from '../api/invoices';
import { vendorsApi } from '../api/vendors';
import { serviceAgreementsApi } from '../api/serviceAgreements';
import { partnerServiceAgreementsApi } from '../api/partnerServiceAgreements';
import { externalVendorsApi } from '../api/externalVendors';
import { permissionsApi } from '../api/permissions';
import { dataReconciliationApi } from '../api/dataReconciliation';
import vendorAccountUnderwriting from './vendorAccountUnderwriting';
import transactionLabels from './transactionLabels';
import transactionMatching from './transactionMatching';
import matchingDashboard from './matchingDashboard';
import scheduledVendorCollections from './scheduledVendorCollections';
import serviceAgreements from './serviceAgreements';
import configurationSettings from './configurationSettings';
import uccs from './uccs';
import vendorSubAccounts from './vendorSubAccounts';
import programPromotions from './programPromotions';
import factoringAccess from './factoringAccess';
import vendorCsvImport from './vendorCsvImport';
import { vendorCsvImportApi } from '../api/vendorCsvImport';
import { partnerRevSharesApi } from '../api/partnerRevShares';
import { partnersApi } from '../api/partners';
import { emailSequencesApi } from '../api/emailSequences';
import { emailTemplatesApi } from '../api/emailTemplates';
import { faqsApi } from '../api/faqs';
import yieldMonitoring from './yieldMonitoring';
import transactionMatchExplorer from './transactionMatchExplorer';
import transactionMatchingParams from './transactionMatchingParams';
import partnerRevShares from './partnerRevShares';
import svbLoanTape from './svbLoanTape';
import portfolioMonitor from './portfolioMonitor';
import portfolioLimitEdits from './portfolioLimitEdits';
import faqs from './faqs';

const reducer = combineReducers({
  permissions,
  acceleratedPayout,
  abandonedUsers,
  adjustments,
  adjustmentGroups,
  anomalies,
  auth,
  cohorts,
  collections,
  eligibleInvoices,
  enablementV2,
  vendorEmailSequences,
  actionItems,
  globalSearch,
  partnerIntegrations,
  programs,
  invoices,
  invoiceQuarantines,
  invoiceLineItems,
  vendorTransfers,
  vendorDocuments,
  onboardings,
  reconciliation,
  vendors,
  clients,
  facilitators,
  externalClients,
  externalVendors,
  externalClientVendors,
  kpis,
  invoiceApprovals,
  invoiceAdjustmentApprovals,
  revenue,
  tasks,
  batchSweeps,
  repaymentItems,
  vendorSurveys,
  vendorAccountUnderwriting,
  transactionLabels,
  transactionMatching,
  matchingDashboard,
  scheduledVendorCollections,
  serviceAgreements,
  configurationSettings,
  uccs,
  vendorSubAccounts,
  programPromotions,
  factoringAccess,
  vendorCsvImport,
  yieldMonitoring,
  transactionMatchExplorer,
  transactionMatchingParams,
  partnerRevShares,
  svbLoanTape,
  portfolioMonitor,
  portfolioLimitEdits,
  faqs,
  [vendorCsvImportApi.reducerPath]: vendorCsvImportApi.reducer,
  [paymentsApi.reducerPath]: paymentsApi.reducer,
  [invoicesApi.reducerPath]: invoicesApi.reducer,
  [aprPortfolioApi.reducerPath]: aprPortfolioApi.reducer,
  [vendorsApi.reducerPath]: vendorsApi.reducer,
  [externalVendorsApi.reducerPath]: externalVendorsApi.reducer,
  [serviceAgreementsApi.reducerPath]: serviceAgreementsApi.reducer,
  [partnerServiceAgreementsApi.reducerPath]: partnerServiceAgreementsApi.reducer,
  [permissionsApi.reducerPath]: permissionsApi.reducer,
  [dataReconciliationApi.reducerPath]: dataReconciliationApi.reducer,
  [partnerRevSharesApi.reducerPath]: partnerRevSharesApi.reducer,
  [partnersApi.reducerPath]: partnersApi.reducer,
  [emailSequencesApi.reducerPath]: emailSequencesApi.reducer,
  [emailTemplatesApi.reducerPath]: emailTemplatesApi.reducer,
  [faqsApi.reducerPath]: faqsApi.reducer,
});

export default reducer;
